import { render, staticRenderFns } from "./LazyVideo.vue?vue&type=template&id=77e2c499&scoped=true&"
import script from "./LazyVideo.vue?vue&type=script&lang=js&"
export * from "./LazyVideo.vue?vue&type=script&lang=js&"
import style0 from "./LazyVideo.vue?vue&type=style&index=0&id=77e2c499&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e2c499",
  null
  
)

export default component.exports